import AnalyticsFoodCostByCategory from './foodCost/byCategory';
import Performance from './businessIntelligence/performance';

const AnalyticsModule = {
  AnalyticsFoodCostByCategory,
  Performance,
};

export default AnalyticsModule;
